export default __webpack_public_path__ + "static/media/1-3-appHome.fe6490b7.png";